module.exports = __webpack_public_path__ + "static/media/table-loader.9fac934b.svg";